"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RankingsApi = function (_BaseApi) {
  (0, _inherits2["default"])(RankingsApi, _BaseApi);

  function RankingsApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, RankingsApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(RankingsApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLeaderBoardByUserId", function (_ref) {
      var challengeId = _ref.challengeId,
          clientId = _ref.clientId,
          _ref$rankingType = _ref.rankingType,
          rankingType = _ref$rankingType === void 0 ? 'users' : _ref$rankingType,
          userId = _ref.userId,
          gender = _ref.gender,
          group = _ref.group,
          categoryParams = _ref.categoryParams,
          sort = _ref.sort,
          country = _ref.country,
          topParentChallenge = _ref.topParentChallenge,
          topParent = _ref.topParent,
          groupChallenge = _ref.groupChallenge,
          week = _ref.week,
          month = _ref.month,
          year = _ref.year,
          sport = _ref.sport,
          sportCategory = _ref.sportCategory,
          progress = _ref.progress,
          allTime = _ref.allTime;
      return _this.api.get("/clients/".concat(clientId, "/").concat(rankingType, "/leaderboard/").concat(userId), {
        params: _objectSpread({
          challengeId: challengeId,
          sort: sort,
          gender: gender,
          group: group,
          country: country,
          topParentChallenge: topParentChallenge,
          topParent: topParent,
          groupChallenge: groupChallenge,
          week: week,
          month: month,
          year: year,
          sport: sport,
          sportCategory: sportCategory,
          progress: progress,
          allTime: allTime
        }, categoryParams)
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLeaderBoardByGroupId", function (_ref2) {
      var challengeId = _ref2.challengeId,
          clientId = _ref2.clientId,
          groupId = _ref2.groupId,
          parent = _ref2.parent,
          sort = _ref2.sort,
          progress = _ref2.progress,
          _ref2$rankingType = _ref2.rankingType,
          rankingType = _ref2$rankingType === void 0 ? 'groups' : _ref2$rankingType,
          subgroup = _ref2.subgroup,
          topParentChallenge = _ref2.topParentChallenge,
          topParent = _ref2.topParent,
          week = _ref2.week,
          month = _ref2.month,
          year = _ref2.year,
          sport = _ref2.sport,
          sportCategory = _ref2.sportCategory,
          allTime = _ref2.allTime;
      return _this.api.get("/clients/".concat(clientId, "/").concat(rankingType, "/leaderboard/").concat(groupId), {
        params: {
          challengeId: challengeId,
          parent: parent,
          progress: progress,
          subgroup: subgroup,
          topParentChallenge: topParentChallenge,
          topParent: topParent,
          week: week,
          month: month,
          year: year,
          sort: sort,
          sport: sport,
          sportCategory: sportCategory,
          allTime: allTime
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLeaderBoard", function (_ref3) {
      var challengeId = _ref3.challengeId,
          clientId = _ref3.clientId,
          gender = _ref3.gender,
          group = _ref3.group,
          limit = _ref3.limit,
          month = _ref3.month,
          week = _ref3.week,
          parent = _ref3.parent,
          year = _ref3.year,
          progress = _ref3.progress,
          _ref3$rankingType = _ref3.rankingType,
          rankingType = _ref3$rankingType === void 0 ? 'groups' : _ref3$rankingType,
          skip = _ref3.skip,
          sort = _ref3.sort,
          subgroup = _ref3.subgroup,
          topParent = _ref3.topParent,
          categoryParams = _ref3.categoryParams,
          search = _ref3.search,
          country = _ref3.country,
          topParentChallenge = _ref3.topParentChallenge,
          groupChallenge = _ref3.groupChallenge,
          sport = _ref3.sport,
          sportCategory = _ref3.sportCategory,
          groupChildrenId = _ref3.groupChildrenId,
          allTime = _ref3.allTime;
      return _this.api.get("/clients/".concat(clientId, "/").concat(rankingType, "/leaderboard").concat(groupChildrenId ? "/".concat(groupChildrenId) : ""), {
        params: _objectSpread({
          challengeId: challengeId,
          gender: gender,
          group: group,
          limit: limit,
          parent: parent,
          progress: progress,
          skip: skip,
          sort: sort,
          subgroup: subgroup,
          topParent: topParent,
          week: week,
          month: month,
          year: year,
          search: search,
          country: country,
          topParentChallenge: topParentChallenge,
          groupChallenge: groupChallenge,
          sport: sport,
          sportCategory: sportCategory,
          allTime: allTime
        }, categoryParams),
        fullResponse: true
      });
    });
    return _this;
  }

  return RankingsApi;
}(_createApi.BaseApi);

var _default = RankingsApi;
exports["default"] = _default;
//# sourceMappingURL=rankings.js.map